import styled from "styled-components";
import {colors} from "nxtconstants";

export const GPL_ACCENT = colors.chartAccent;
export const GPL_ACCENT_TEXT = colors.chartAccentText;

export const CalculatorSection = styled.section`
  padding: 4rem 0 6rem;
  font-family: "Lato";

  @media (max-width: 768px) {
    padding: 2rem 0 ;
  }
`;

export const PageTitle = styled.h1`
  font-size: 4.2rem;
  font-family: "DM Serif Display";
  font-weight: 400;
  color: ${colors.textBlack};
  width: 85%;
  max-width: 125rem;
  margin: 0 auto 3.2rem;
  letter-spacing: -0.02em;

  @media (max-width: 768px) {
    font-size: 2.8rem;
    margin: 0 auto 2rem;
  }
`;

export const MobileTabContainer = styled.div`
  display: none;
  width: 85%;
  max-width: 125rem;
  margin: 0 auto 2rem;
  border: 1px solid ${colors.lightGray};
  border-radius: 1.2rem;
  overflow: hidden;
  background: ${colors.white};

  @media (max-width: 768px) {
    display: flex;
  }
`;

export const MobileTabButton = styled.button`
  flex: 1;
  border: none;
  cursor: pointer;
  padding: 1.2rem 1.6rem;
  font-family: "Lato";
  font-size: 1.6rem;
  font-weight: 600;
  background: ${(props) => (props.active ? colors.secondary : colors.white)};
  color: ${(props) => (props.active ? colors.textBlack : colors.textGray)};
  transition: background 0.2s ease;

  &:not(:last-child) {
    border-right: 1px solid ${colors.lightGray};
  }
`;

export const CalculatorWrapper = styled.div`
  display: grid;
  grid-template-columns: 50rem minmax(0, 1fr);
  gap: 4rem 6rem;
  width: 85%;
  max-width: 125rem;
  margin: 0 auto;
  align-items: start;
  background-color: ${colors.white};
  border: 1px solid ${colors.lightGray};
  border-radius: 2rem;
  padding: 4rem;
  box-sizing: border-box;

  @media (max-width: 850px) {
    grid-template-columns: 1fr;
    gap: 0;
    width: 85%;
    padding: 2.4rem;
  }

  @media (max-width: 768px) {
    padding: 0;
    background: transparent;
    border: none;
    border-radius: 0;
  }
`;

export const ControlPanel = styled.div`
  width: 100%;
  min-width: 0;

  @media (max-width: 768px) {
    display: ${(props) => (props.$hidden ? "none" : "block")};
    background-color: ${colors.white};
    padding: 2.4rem;
    width: 100%;
    margin: 0 auto;
    border: 1px solid ${colors.lightGray};
    border-radius: 1.2rem;
  }
`;

export const ResultsPanel = styled.div`
  min-width: 0;
  overflow: hidden;

  @media (max-width: 768px) {
    display: ${(props) => (props.$hidden ? "none" : "block")};
    background-color: ${colors.white};
    padding: 2.4rem;
    width: 100%;
    margin: 0 auto;
    border: 1px solid ${colors.lightGray};
    border-radius: 1.2rem;
  }
`;

export const SummaryCard = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 2rem;
  background-color: ${colors.secondary};
  padding: 2.4rem 2.8rem;
  border-radius: 1.2rem;
  margin-bottom: 2.4rem;
  min-width: 0;

  @media (max-width: 1200px) {
    grid-template-columns: 1fr;
    gap: 1.6rem;
    padding: 2rem;
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

export const MobileSummaryCard = styled.div`
  display: none;
  border: 1px solid ${colors.lightGray};
  border-radius: 1.2rem;
  overflow: hidden;
  margin-bottom: 2rem;

  @media (max-width: 768px) {
    display: block;
  }
`;

export const MobileSummaryBlock = styled.div`
  padding: 1.6rem 2rem;
  background: ${colors.secondary};
  min-width: 0;

  &:not(:first-child) {
    border-top: 1px solid rgba(0, 0, 0, 0.06);
  }
`;

export const SummaryBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  min-width: 0;
`;

export const SummaryLabel = styled.span`
  font-size: 1.8rem;
  color: ${colors.textGray};
  line-height: 1.4;
  word-break: break-word;
`;

export const SummaryValueRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 0.4rem;
  min-width: 0;
`;

export const SummarySuffix = styled.span`
  font-size: 1.2rem;
  color: ${colors.textGray};
  line-height: 1.4;
`;

export const SummaryValue = styled.span`
  font-size: 2rem;
  color: ${colors.textBlack};
  line-height: 1.2;
  word-break: break-word;

  @media (max-width: 768px) {
    font-size: 1.8rem;
  }
`;

export {ViewToggleButton, ViewToggleContainer} from "../ViewToggleStyles";

export const ChartLayout = styled.div`
  display: grid;
  grid-template-columns: minmax(18rem, 22rem) 1fr;
  gap: 3rem;
  align-items: center;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
`;

export const DonutContainer = styled.div`
  width: 100%;
  max-width: 22rem;
  height: 22rem;
  margin: 0 auto;

  @media (max-width: 768px) {
    height: 20rem;
    max-width: 20rem;
  }
`;

export const LegendPanel = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2.4rem;
`;

export const LegendRow = styled.div`
  display: grid;
  grid-template-columns: 0.6rem 1fr;
  gap: 1.6rem;
  align-items: start;
`;

export const LegendBar = styled.div`
  width: 0.6rem;
  height: 5.6rem;
  border-radius: 0.4rem;
  background-color: ${(props) => props.color};
`;

export const LegendContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
`;

export const LegendTitle = styled.span`
  font-size: 1.4rem;
  color: ${colors.textGray};
`;

export const LegendValue = styled.span`
  font-size: 2rem;
  font-weight: 400;
  color: ${colors.textBlack};
  line-height: 1.3;
  word-break: break-word;

  @media (max-width: 768px) {
    font-size: 1.7rem;
  }
`;

export const TableWrapper = styled.div`
  width: 100%;
  max-width: 100%;
  max-height: 50rem;
  overflow-x: auto;
  overflow-y: auto;
  border: 1px solid ${colors.lightGray};
  border-radius: 1.2rem;
  -webkit-overflow-scrolling: touch;

  @media (max-width: 768px) {
    max-height: 36rem;
  }
`;

export const DataTable = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  font-family: "Lato";
  font-size: 1.4rem;

  th,
  td {
    padding: 1.2rem 1rem;
    text-align: right;
    border-bottom: 1px solid ${colors.lightGray};
    white-space: nowrap;
  }

  th:first-child,
  td:first-child {
    text-align: left;
  }

  th {
    color: ${colors.textGray};
    font-weight: 500;
    background: #fafafa;
    position: sticky;
    top: 0;
    z-index: 1;
    box-shadow: inset 0 -1px 0 ${colors.lightGray};
  }

  td {
    color: ${colors.textBlack};
  }

  tr:last-child td {
    border-bottom: none;
  }
`;
